import { LayoutPanelLeft, MessagesSquare, ShieldCheck, Users } from 'lucide-react';
import { DELIVERY_MODEL, ENGAGEMENT } from '../../data/siteData';
import { Reveal } from '../../hooks/useMotion';

const ICONS = { MessagesSquare, LayoutPanelLeft, ShieldCheck, Users };

export const DeliveryModel = () => (
  <>
    <div className="model" data-testid="delivery-model">
      {DELIVERY_MODEL.map((m, i) => {
        const Icon = ICONS[m.icon];
        return (
          <Reveal key={m.title} delay={i * 80}>
            <span className="ic"><Icon size={22} strokeWidth={1.7} /></span>
            <div className="where">{m.where}</div>
            <h3>{m.title}</h3>
            <p>{m.text}</p>
          </Reveal>
        );
      })}
    </div>
    <div className="engage">
      <span className="lbl">Recommended engagement</span>
      {ENGAGEMENT.map((e) => e.title).join(' → ')}
    </div>
  </>
);

export default DeliveryModel;
